import { Component, OnInit } from '@angular/core';
import { Application } from '../../../shared/user.model';
import { UserService } from '../../../shared/user.service';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import swal1 from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorHandler } from '../../../shared/ErrorHandler';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-phase-form',
  templateUrl: './phase-form.component.html',
  styleUrls: ['./phase-form.component.css']
})
export class PhaseFormComponent implements OnInit {

  title="Add Phase";
  data : any = {};
  formInvalid : boolean = false;
  p : any = {};
  Phase_Id : number;
  mode : string;

  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler,
    private datePipe:DatePipe) 
  { }

  ngOnInit() {
    debugger
    this.route.params.subscribe(params => {      
      this.Phase_Id = params['Phase_Id'];  
      this.mode  =   params['mode'];
      
      if(this.Phase_Id !=null){
        this.GetPhaseById(this.Phase_Id)
      }    
  });
  
  if(this.mode=='view'){
    this.title = "View Phase Proceedings";
  }
  else if(this.mode=='edit'){
    this.title = "Edit Phase Proceedings";
  }  
  }

  SavePhase(Phase: NgForm){    
    debugger
    
    if(Phase.invalid)
    {
      this.formInvalid = true;
      swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
      return;
    }  
   

    else{   
                                  
            this.data = this.userService.PostPhase(Phase.value);    
            this.data.subscribe(
            (response) => {
              Phase.reset();
              Phase.resetForm();
              Phase.form.markAsPristine();
              Phase.form.markAsUntouched();        
              swal('Success!', 'Phase Added Successfully .', 'success');
              this.router.navigate(['/home/phases']) ;   
              document.getElementById('loader-spinner').style.display = "none";           
            }, (error) => {
              document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401) {
                this.errorHandler.HandlerError(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
            });    
    
    } 
  }

  GetPhaseById(Phase_Id){
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
        this.data = this.userService.GetByIdPhase(Phase_Id);
        this.data.subscribe(
          (response: any) => {
            this.p = response;        
            
            // if (this.ap.AP_Date != null)
            //   this.ap.AP_Date = ((this.ap.AP_Date).split('T'))[0];
            // if (this.ap.AP_Date != null)
            //  this.ap.AP_Date = ((this.ap.AP_Date).split('T'))[0];    
                    console.log("getbyid");console.log(response);
    
            document.getElementById('loader-spinner').style.display = "none";
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
          });
  }
  UpdatePhase(Phase: NgForm) { 
       
    this.data = this.userService.UpdatePhase(Phase.value,this.Phase_Id);
   this.data.subscribe(
     (response) => {
      Phase.reset();
      Phase.resetForm();
      Phase.form.markAsPristine();
      Phase.form.markAsUntouched();           
                   
       swal('Success!', 'Phase updated Successfully .', 'success');
       document.getElementById('loader-spinner').style.display = "none";   
       this.router.navigate(['/home/phases']) ;          
     }, (error) => {
       document.getElementById('loader-spinner').style.display = "none";
       if (error.status == 401) {
         this.errorHandler.HandlerError(error);
       }
       else if (error.status == 400) {
         swal('Warning!', error.error.Message, 'warning');
       }
     });   
}

Cancel(){ 
  this.p.Phase_Name='';
  
}




  

}




// WEBPACK FOOTER //
// ./src/app/master/phases/phase-form/phase-form.component.ts